import rr from "../common/base-feed.js";
import { logCardClick, logCardImpressions } from "../Card/index.js";
import { requestContentCardsRefresh } from "./request-content-cards-refresh.js";
export default class ContentCards extends rr {
  constructor(r, e) {
    super(r, e);
  }
  getUnviewedCardCount() {
    return super.getUnreadCardCount();
  }
  logCardImpressions(r) {
    logCardImpressions(r, !0);
  }
  logCardClick(r) {
    return logCardClick(r, !0);
  }
  sr() {
    requestContentCardsRefresh();
  }
  nr() {
    return !0;
  }
}
ContentCards.dr = 6e4;
